module.exports = __webpack_public_path__ + "static/media/pg_dnm_tide_pool.b3738347.jpg";